<div class="n-historico-container">
  <!-- Filtros Rápidos -->
  <div class="n-filter-bar flex align-items-center gap-2 mb-3">
    <button
      type="button"
      class="n-pill-filter cursor-pointer border-none font-semibold text-xs py-2 px-3 border-round-xl transition-all"
      [class.active]="filtroStatus() === 'todos'"
      (click)="setFiltro('todos')"
    >
      {{ 'BARDO_CLIENTES.FILTROS.TODOS' | translate:{ count: historicoItems().length } }}
    </button>
    <button
      type="button"
      class="n-pill-filter atendido cursor-pointer border-none font-semibold text-xs py-2 px-3 border-round-xl transition-all"
      [class.active]="filtroStatus() === 'ATENDIDO'"
      (click)="setFiltro('ATENDIDO')"
    >
      {{ 'BARDO_CLIENTES.FILTROS.ATENDIDOS' | translate }}
    </button>
    <button
      type="button"
      class="n-pill-filter confirmado cursor-pointer border-none font-semibold text-xs py-2 px-3 border-round-xl transition-all"
      [class.active]="filtroStatus() === 'CONFIRMADO'"
      (click)="setFiltro('CONFIRMADO')"
    >
      {{ 'BARDO_CLIENTES.FILTROS.CONFIRMADOS' | translate }}
    </button>
    <button
      type="button"
      class="n-pill-filter cancelado cursor-pointer border-none font-semibold text-xs py-2 px-3 border-round-xl transition-all"
      [class.active]="filtroStatus() === 'CANCELADO'"
      (click)="setFiltro('CANCELADO')"
    >
      {{ 'BARDO_CLIENTES.FILTROS.CANCELADOS' | translate }}
    </button>
  </div>

  <!-- Loading State -->
  @if (carregando()) {
    <div class="flex justify-content-center py-5 text-primary text-xl">
      <i class="pi pi-spin pi-spinner"></i>
    </div>
  } @else {
    <!-- Timeline List -->
    @if (itemsFiltrados().length > 0) {
      <div class="n-historico-list flex flex-column gap-2">
        @for (item of itemsFiltrados(); track item.id) {
          <div class="n-historico-card p-3 border-round-2xl border-1 border-200 bg-white flex flex-column gap-2">
            <!-- Header do Card: Data/Hora + Badge de Status -->
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center gap-2 text-500 text-xs font-medium">
                <i class="pi pi-calendar text-400"></i>
                <span>{{ formatarDataBr(item.data) }}</span>
                @if (item.horaInicio) {
                  <span>{{ 'BARDO_CLIENTES.HISTORICO_AS' | translate:{ hora: item.horaInicio } }}</span>
                }
              </div>

              <!-- Badge de Status -->
              <span
                class="n-status-badge text-xs font-bold px-2 py-1 border-round-lg uppercase"
                [class.atendido]="item.status === 'ATENDIDO'"
                [class.confirmado]="item.status === 'CONFIRMADO'"
                [class.cancelado]="item.status === 'CANCELADO'"
              >
                {{ (item.status === 'ATENDIDO' ? 'BARDO_CLIENTES.STATUS_ATENDIDO' : item.status === 'CONFIRMADO' ? 'BARDO_CLIENTES.STATUS_CONFIRMADO' : 'BARDO_CLIENTES.STATUS_CANCELADO') | translate }}
              </span>
            </div>

            <!-- Corpo do Card: Serviço e Profissional -->
            <div class="flex align-items-center justify-content-between min-w-0">
              <div class="flex flex-column min-w-0">
                <span class="n-servico-nome font-bold text-sm text-900 text-overflow-ellipsis overflow-hidden white-space-nowrap">
                  {{ item.servicoNome }}
                </span>
                @if (item.profissionalNome) {
                  <span class="text-xs text-500 flex align-items-center gap-1 mt-1">
                    <i class="pi pi-user text-300"></i> {{ item.profissionalNome }}
                  </span>
                }
              </div>

              <!-- Valor (se houver) -->
              @if (item.valor) {
                <span class="n-valor-tag font-bold text-sm text-primary flex-shrink-0 ml-2">
                  {{ item.valor | moeda }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <!-- Empty State -->
      <div class="n-empty-historico text-center py-5 text-secondary flex flex-column align-items-center justify-content-center">
        <i class="pi pi-history text-4xl block mb-2 text-400"></i>
        <h4 class="m-0 text-base font-semibold text-700">
          {{ 'BARDO_CLIENTES.NENHUM_HISTORICO_ENCONTRADO' | translate }}
        </h4>
        <p class="m-0 text-sm text-500 mt-1">
          {{ 'BARDO_CLIENTES.NENHUM_HISTORICO_FILTRO' | translate }}
        </p>
      </div>
    }
  }
</div>
